import { Button, Modal } from "antd";
import { useState } from "react";
import "./ConfirmationModal.scss";
import { DisplayUploadDto } from "../../domain/DisplayUploadDto";
import QRDisplayUploadsApi from "../../api/QRDisplayUploadsApi";

export interface DeleteUploadModalProps {
  upload: DisplayUploadDto | null;
  isVisible: boolean;
  onClose: (fetch: boolean) => void;
}

export function DeleteUploadModal({
  upload,
  isVisible,
  onClose,
}: DeleteUploadModalProps) {
  const [saving, setSaving] = useState(false);

  function remove() {
    setSaving(true);
    QRDisplayUploadsApi.deleteDisplayUpload(upload?.id!).then(() => {
      setSaving(false);
      onClose(true);
    }).catch(() => {
      setSaving(false);
      onClose(true);
    });
  }

  return (
    <Modal
      className={"confirmation-modal clean"}
      visible={isVisible}
      onCancel={() => onClose(false)}
    >
      <header>
        <h2>Are you sure?</h2>
      </header>

      <p>This upload will be permanently deleted from your account.</p>

      <footer>
        <Button size={"large"} onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={remove}
          loading={saving}
        >
          Delete
        </Button>
      </footer>
    </Modal>
  );
}
